import Vue from "vue"
/* import componentsApi from "../../api/components" */
import utilsApi from "@/api/utils"
import { createFetchPageAction } from "@/store/helpers/createFetchPageAction"
const initialObject = {
  _id: undefined,
  site: undefined,
  name: undefined,
  body: undefined,
  default_locale: undefined,
  locales: undefined,
  status: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  translation: undefined
}

const ignoreObjectsFields = ["createdAt", "updatedAt"]

const initialState = {
  translations: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  dataShape: [],
  object: initialObject,
  isNew: false,
  selected: []
}
// general state for the site
const state = Object.assign({}, initialState)

const getters = {
  translations: (state) => state.translations,
  translationsIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  translationsError: (state) => state.error,
  translations_Object: (state) => state.object,
  translations_isNew: (state) => state.isNew,
  translations_selected: (state) => state.selected,
  translations_dataShape: (state) => state.dataShape
}
const actions = {
  async DELETE_translations({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("translations", object)
    if (apiResponse != null) {
      //commit("TRANSLATIONS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_translations", state.page)
      return true
    } else {
      commit("TRANSLATIONS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_translations({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_translations", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_translations", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_translationsState({ commit }, payload) {
    commit("SET_translations", payload)
    return true
  },
  async UPDATE_translations({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("translations", filtered)
    if (apiResponse != null) {
      commit("TRANSLATIONS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_translations", state.page)
      return true
    } else {
      commit("TRANSLATIONS_ERROR")
      return false
    }
  },
  async CREATE_translations({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("translations", object)
    if (apiResponse != null) {
      commit("SET_translations", {
        param: "object",
        value: apiResponse.translation
      })
      dispatch("FETCH_PAGE_translations", state.page)
      return true
    } else {
      commit("TRANSLATIONS_ERROR")
      return false
    }
  },
  async FETCH_translations({ commit }) {
    let apiResponse = await utilsApi.getObjects("translations")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("TRANSLATIONS_SETTING", apiResponse)
      return true
    } else {
      commit("TRANSLATIONS_ERROR")
      return false
    }
  },

  FETCH_PAGE_translations: createFetchPageAction(
    "translations",
    "TRANSLATIONS_SETTING",
    "TRANSLATIONS_ERROR",
    "translations"
  ),

  UPDATE_OBJECT_translations({ commit }, payload) {
    commit("SET_OBJECT_TRANSLATION", payload)
    return true
  },
  CLEAN_OBJECT_translations({ commit }) {
    commit("SET_OBJECT_TRANSLATION_INITIAL")
    return true
  },
  async CLEAN_STORE_translations({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_translations", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_translations({ commit }, payload) {
    commit("SET_SELECTED_translations", payload)
    return true
  }
}
const mutations = {
  TRANSLATIONS_SETTING: (state, { translations, count = undefined, page }) => {
    state.count = count ?? state.translations.length
    state.page = page ?? state.page
    state.translations = translations
    state.fetched = true
    state.error = false
  },
  TRANSLATIONS_ERROR: (state) => {
    state.translations = null
    state.fetched = true
    state.error = false
    state.dataShape = []
  },
  SET_OBJECT_TRANSLATION: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_TRANSLATION_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_translations: (state, selectedPages) => {
    state.selected = selectedPages
  },
  SET_translations: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
